"use client";
import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { useAgent } from "../../../../../utils/agent/AgentProvider.js";
import { useReducer, useEffect, cloneElement } from "react";
import { useTracking } from "react-tracking";
import { AccountDrawerUI } from "../AccountDrawerUI/index.js";
import { useAuth } from "../../../../../hooks/auth/useAuth/index.js";
import { Actions } from "./constants.js";
const initialState = {
  isLoading: true,
  isLoggedIn: false,
  memberStatus: void 0
};
function reducer(state, action) {
  switch (action.type) {
    case Actions.setIsLoading:
      return { ...state, isLoading: action.payload };
    case Actions.setIsLoggedIn:
      return { ...state, isLoggedIn: action.payload };
    case Actions.setIsOpen:
      return { ...state, isOpen: action.payload };
    case Actions.setMemberStatus:
      return { ...state, memberStatus: action.payload };
    default:
      return state;
  }
}
const AccountDrawerAuth = ({
  children,
  defaultOpen,
  ...rest
}) => {
  const { trackEvent } = useTracking();
  const { agent } = useAgent();
  const {
    signOut,
    isUserSignedIn,
    getToken,
    isLoading: instanceLoading
  } = useAuth();
  const [{ isLoading, isLoggedIn, isOpen, memberStatus }, dispatch] = useReducer(reducer, {
    ...initialState,
    isOpen: !!defaultOpen
  });
  const initializeSignOut = () => {
    if (!instanceLoading) {
      signOut();
    } else {
      console.error(
        "AccountDrawerAuth:: Sign out failed as msal instance is loading"
      );
    }
  };
  useEffect(() => {
    if (!instanceLoading) {
      isUserSignedIn().then((result) => {
        dispatch({
          payload: result,
          type: Actions.setIsLoggedIn
        });
      });
    }
  }, [instanceLoading, isUserSignedIn]);
  useEffect(() => {
    let isCancelled = false;
    const getMembershipStatus = async (agent2) => {
      try {
        const accessToken = await getToken(true);
        if (accessToken) {
          const data = await agent2.getMembershipStatus(accessToken);
          if (!isCancelled) {
            dispatch({
              payload: data,
              type: Actions.setMemberStatus
            });
          }
        }
      } catch (error) {
        if (!isCancelled) {
          console.error("Error fetching member status", error);
        }
      } finally {
        if (!isCancelled) {
          dispatch({ payload: false, type: Actions.setIsLoading });
        }
      }
    };
    if (agent && isOpen && !memberStatus && isLoggedIn && !instanceLoading) {
      dispatch({ payload: true, type: Actions.setIsLoading });
      getMembershipStatus(agent);
    } else {
      dispatch({ payload: false, type: Actions.setIsLoading });
    }
    return () => {
      isCancelled = true;
    };
  }, [agent, isOpen, memberStatus, isLoggedIn, getToken, instanceLoading]);
  const handleClick = () => {
    trackEvent({
      component: {
        identifier: "header",
        trackedData: ["Open Account Flyout"],
        type: "ui"
      },
      trackType: "navigation"
    });
    dispatch({ payload: !isOpen, type: Actions.setIsOpen });
  };
  const handleClose = () => {
    dispatch({ payload: false, type: Actions.setIsOpen });
  };
  if (!children) return null;
  const buttonWithHandler = cloneElement(children, {
    onClick: handleClick
  });
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    buttonWithHandler,
    /* @__PURE__ */ jsx(
      AccountDrawerUI,
      {
        ...rest,
        isLoading,
        isOpen,
        memberStatus,
        onClose: handleClose,
        onSignOut: initializeSignOut
      }
    )
  ] });
};
export {
  AccountDrawerAuth
};
